import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@workspace/web-ui/components/skeleton";
import { useState } from "react";
import { getTasksByEncounterIdQuery } from "../../api/tasks/query";
import { TaskCard } from "./task-card";

interface Props {
  encounterId: string
  patientId: string
}

const TaskContainer = ({ encounterId, patientId }: Props) => {
  const [remountKey, setRemountKey] = useState(0);

  const { data: tasks, isLoading } = useQuery(getTasksByEncounterIdQuery(encounterId));

// Then get the task prescription
// const taskPrescription = useQueries({
//   queries: tasks?.recommendedTasks
//     ? tasks?.recommendedTasks.map((task) => {
//         return {
//           queryKey: ['prescription', task.prescriptionId],
//           queryFn: () => getTasksByEncounterIdQuery(id),
//         }
//       })
//     : [], // if tasks is undefined, an empty array will be returned
// })
  if (isLoading) {
    return <Skeleton className="w-full h-40" />
  } else if (!tasks) return null;

  const { recommendedTasks } = tasks || {}

  if (!encounterId) return null;

  // Callback to trigger remount
  const handleTaskDeleted = () => {
    setRemountKey(prev => prev + 1);
  };

  return (
    <div
      key={remountKey}
      className="flex gap-2 items-center flex-col w-full"
      aria-label="tasks"
      role="region"
    >
      {/* {recommendedTasks && recommendedTasks.length > 0 ? ( */}
        {recommendedTasks.map((task) => (
            <TaskCard
              key={task.id}
              id={task.id}
              title={task.name}
              medications={task.medications}
              prescriptionId={task.prescriptionId}
              status={task.status}
              is_erx_sent={task.is_erx_sent}
              encounterId={encounterId ?? ""}
              date={task.createdAt}
              instructions={task.instructions}
              pharmacy={task.pharmacy}
              patientId={patientId}
              onTaskDeleted={handleTaskDeleted}
            />
        ))}

    </div>
  )
}

export default TaskContainer